import React from "react";
import LegalLayout from "@/components/pnp/LegalLayout";
import { CONTACT } from "@/lib/pnp";

export default function Datenschutz() {
  return (
    <LegalLayout kicker="Datenschutz · DSGVO" title="Datenschutzerklärung">
      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:
      </p>
      <p>
        Paul Drechsler · P&amp;P Gartenservice
        <br />
        Schelkenwiese 32, 35305 Grünberg
        <br />
        E-Mail:{" "}
        <a className="text-[#17C964] hover:underline" href={CONTACT.emailHref}>
          {CONTACT.email}
        </a>
        <br />
        Telefon:{" "}
        <a className="text-[#17C964] hover:underline" href={CONTACT.telHref}>
          {CONTACT.phone}
        </a>
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">2. Allgemeine Hinweise</h2>
      <p>
        Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir behandeln
        Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen
        Datenschutzvorschriften (DSGVO, BDSG) sowie dieser Datenschutzerklärung.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        3. Erhebung von Daten beim Besuch der Website (Server-Logfiles)
      </h2>
      <p>
        Beim Aufruf unserer Website werden durch den Hosting-Provider automatisch
        Informationen in sogenannten Server-Logfiles gespeichert:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>IP-Adresse (in gekürzter Form)</li>
        <li>Datum und Uhrzeit der Anfrage</li>
        <li>Referrer-URL</li>
        <li>verwendeter Browser und Betriebssystem</li>
      </ul>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
        Sicherheit und Stabilität der Website). Die Daten werden nach spätestens 14 Tagen
        gelöscht, sofern keine sicherheitsrelevanten Ereignisse eine längere Speicherung
        erfordern.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        4. Kontaktformular, E-Mail, Telefon &amp; WhatsApp
      </h2>
      <p>
        Wenn Sie uns per Kontaktformular, E-Mail, Telefon oder WhatsApp erreichen, werden
        Ihre Angaben (Name, E-Mail-Adresse, ggf. Telefonnummer, Nachrichteninhalt) zum
        Zwecke der Bearbeitung der Anfrage sowie für den Fall von Anschlussfragen
        gespeichert.
      </p>
      <p>
        Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen /
        Vertragserfüllung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
        Beantwortung Ihrer Anfrage). Die Daten werden gelöscht, sobald ihr
        Speicherzweck entfällt und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        5. WhatsApp-Kommunikation
      </h2>
      <p>
        Bei Kontaktaufnahme über den WhatsApp-Button verlassen Sie unsere Website und
        gelangen zu WhatsApp (Meta Platforms Ireland Ltd.). Meta erhebt und verarbeitet
        dabei personenbezogene Daten in eigener Verantwortung. Näheres in der{" "}
        <a
          className="text-[#17C964] hover:underline"
          href="https://www.whatsapp.com/legal/privacy-policy-eea"
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp-Datenschutzerklärung
        </a>
        .
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        6. Instagram-Verlinkung
      </h2>
      <p>
        Auf unserer Website befinden sich Verlinkungen zu unserem Instagram-Profil
        (Meta Platforms Ireland Ltd.). Erst durch aktives Anklicken werden Daten an
        Instagram übertragen. Weitere Informationen finden Sie in den{" "}
        <a
          className="text-[#17C964] hover:underline"
          href="https://privacycenter.instagram.com/policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram-Datenschutzhinweisen
        </a>
        .
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        7. Externe Schriftarten (Google Fonts, Fontshare)
      </h2>
      <p>
        Zur einheitlichen Darstellung werden Schriftarten von Google Fonts sowie
        Fontshare (Indian Type Foundry) geladen. Beim Aufruf wird eine Verbindung zu
        deren Servern hergestellt, wodurch Ihre IP-Adresse an den Anbieter übertragen
        werden kann. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (einheitliche und
        ansprechende Darstellung).
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        8. Cookies
      </h2>
      <p>
        Diese Website verwendet keine Marketing- oder Tracking-Cookies. Es werden
        ausschließlich technisch notwendige Sitzungsdaten verwendet, die für den Betrieb
        der Seite erforderlich sind.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        9. Ihre Rechte
      </h2>
      <p>Sie haben jederzeit das Recht auf:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
        <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
      </ul>
      <p>
        Zur Ausübung Ihrer Rechte genügt eine E-Mail an{" "}
        <a className="text-[#17C964] hover:underline" href={CONTACT.emailHref}>
          {CONTACT.email}
        </a>
        .
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        10. Beschwerderecht bei der Aufsichtsbehörde
      </h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die
        Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. Zuständig
        ist der Hessische Beauftragte für Datenschutz und Informationsfreiheit,
        Gustav-Stresemann-Ring 1, 65189 Wiesbaden.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        11. SSL-/TLS-Verschlüsselung
      </h2>
      <p>
        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
        vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung. Sie erkennen sie am
        Schloss-Symbol in der Adresszeile Ihres Browsers.
      </p>

      <p className="mt-12 text-[#4F6858] text-sm">
        Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
      </p>
    </LegalLayout>
  );
}
